// plugins/velocity.client.js
import Velocity from 'velocity-animate';

export default defineNuxtPlugin(() => {
    return {
        provide: {
            velocity: Velocity
        }
    };
});